import { render } from "./MasterBoardMemberTasksModal.vue?vue&type=template&id=0644e474&scoped=true"
import script from "./MasterBoardMemberTasksModal.vue?vue&type=script&lang=js"
export * from "./MasterBoardMemberTasksModal.vue?vue&type=script&lang=js"

import "./MasterBoardMemberTasksModal.vue?vue&type=style&index=0&id=0644e474&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0644e474"

export default script